export interface Country {
  code: string;
  flag: string;
  name: {
    en: string;
    da: string;
  };
  vatPrefix: string;
}

export const EU_COUNTRIES: Country[] = [
  { code: 'AT', flag: '🇦🇹', name: { en: 'Austria', da: 'Østrig' }, vatPrefix: 'ATU' },
  { code: 'BE', flag: '🇧🇪', name: { en: 'Belgium', da: 'Belgien' }, vatPrefix: 'BE' },
  { code: 'BG', flag: '🇧🇬', name: { en: 'Bulgaria', da: 'Bulgarien' }, vatPrefix: 'BG' },
  { code: 'HR', flag: '🇭🇷', name: { en: 'Croatia', da: 'Kroatien' }, vatPrefix: 'HR' },
  { code: 'CY', flag: '🇨🇾', name: { en: 'Cyprus', da: 'Cypern' }, vatPrefix: 'CY' },
  { code: 'CZ', flag: '🇨🇿', name: { en: 'Czech Republic', da: 'Tjekkiet' }, vatPrefix: 'CZ' },
  { code: 'DK', flag: '🇩🇰', name: { en: 'Denmark', da: 'Danmark' }, vatPrefix: 'DK' },
  { code: 'EE', flag: '🇪🇪', name: { en: 'Estonia', da: 'Estland' }, vatPrefix: 'EE' },
  { code: 'FI', flag: '🇫🇮', name: { en: 'Finland', da: 'Finland' }, vatPrefix: 'FI' },
  { code: 'FR', flag: '🇫🇷', name: { en: 'France', da: 'Frankrig' }, vatPrefix: 'FR' },
  { code: 'DE', flag: '🇩🇪', name: { en: 'Germany', da: 'Tyskland' }, vatPrefix: 'DE' },
  { code: 'GR', flag: '🇬🇷', name: { en: 'Greece', da: 'Grækenland' }, vatPrefix: 'EL' },
  { code: 'HU', flag: '🇭🇺', name: { en: 'Hungary', da: 'Ungarn' }, vatPrefix: 'HU' },
  { code: 'IE', flag: '🇮🇪', name: { en: 'Ireland', da: 'Irland' }, vatPrefix: 'IE' },
  { code: 'IT', flag: '🇮🇹', name: { en: 'Italy', da: 'Italien' }, vatPrefix: 'IT' },
  { code: 'LV', flag: '🇱🇻', name: { en: 'Latvia', da: 'Letland' }, vatPrefix: 'LV' },
  { code: 'LT', flag: '🇱🇹', name: { en: 'Lithuania', da: 'Litauen' }, vatPrefix: 'LT' },
  { code: 'LU', flag: '🇱🇺', name: { en: 'Luxembourg', da: 'Luxembourg' }, vatPrefix: 'LU' },
  { code: 'MT', flag: '🇲🇹', name: { en: 'Malta', da: 'Malta' }, vatPrefix: 'MT' },
  { code: 'NL', flag: '🇳🇱', name: { en: 'Netherlands', da: 'Holland' }, vatPrefix: 'NL' },
  { code: 'PL', flag: '🇵🇱', name: { en: 'Poland', da: 'Polen' }, vatPrefix: 'PL' },
  { code: 'PT', flag: '🇵🇹', name: { en: 'Portugal', da: 'Portugal' }, vatPrefix: 'PT' },
  { code: 'RO', flag: '🇷🇴', name: { en: 'Romania', da: 'Rumænien' }, vatPrefix: 'RO' },
  { code: 'SK', flag: '🇸🇰', name: { en: 'Slovakia', da: 'Slovakiet' }, vatPrefix: 'SK' },
  { code: 'SI', flag: '🇸🇮', name: { en: 'Slovenia', da: 'Slovenien' }, vatPrefix: 'SI' },
  { code: 'ES', flag: '🇪🇸', name: { en: 'Spain', da: 'Spanien' }, vatPrefix: 'ES' },
  { code: 'SE', flag: '🇸🇪', name: { en: 'Sweden', da: 'Sverige' }, vatPrefix: 'SE' },
];

// Non-EU countries commonly used
export const OTHER_COUNTRIES: Country[] = [
  { code: 'NO', flag: '🇳🇴', name: { en: 'Norway', da: 'Norge' }, vatPrefix: 'NO' },
  { code: 'IS', flag: '🇮🇸', name: { en: 'Iceland', da: 'Island' }, vatPrefix: 'IS' },
  { code: 'CH', flag: '🇨🇭', name: { en: 'Switzerland', da: 'Schweiz' }, vatPrefix: 'CHE' },
  { code: 'GB', flag: '🇬🇧', name: { en: 'United Kingdom', da: 'Storbritannien' }, vatPrefix: 'GB' },
  { code: 'US', flag: '🇺🇸', name: { en: 'United States', da: 'USA' }, vatPrefix: 'US' },
  { code: 'CA', flag: '🇨🇦', name: { en: 'Canada', da: 'Canada' }, vatPrefix: 'CA' },
  { code: 'AU', flag: '🇦🇺', name: { en: 'Australia', da: 'Australien' }, vatPrefix: 'AU' },
  { code: 'NZ', flag: '🇳🇿', name: { en: 'New Zealand', da: 'New Zealand' }, vatPrefix: 'NZ' },
  { code: 'JP', flag: '🇯🇵', name: { en: 'Japan', da: 'Japan' }, vatPrefix: 'JP' },
  { code: 'CN', flag: '🇨🇳', name: { en: 'China', da: 'Kina' }, vatPrefix: 'CN' },
  { code: 'IN', flag: '🇮🇳', name: { en: 'India', da: 'Indien' }, vatPrefix: 'IN' },
  { code: 'BR', flag: '🇧🇷', name: { en: 'Brazil', da: 'Brasilien' }, vatPrefix: 'BR' },
  { code: 'MX', flag: '🇲🇽', name: { en: 'Mexico', da: 'Mexico' }, vatPrefix: 'MX' },
  { code: 'AR', flag: '🇦🇷', name: { en: 'Argentina', da: 'Argentina' }, vatPrefix: 'AR' },
  { code: 'ZA', flag: '🇿🇦', name: { en: 'South Africa', da: 'Sydafrika' }, vatPrefix: 'ZA' },
  { code: 'RU', flag: '🇷🇺', name: { en: 'Russia', da: 'Rusland' }, vatPrefix: 'RU' },
  { code: 'TR', flag: '🇹🇷', name: { en: 'Turkey', da: 'Tyrkiet' }, vatPrefix: 'TR' },
  {
    code: 'AE',
    flag: '🇦🇪',
    name: { en: 'United Arab Emirates', da: 'Forenede Arabiske Emirater' },
    vatPrefix: 'AE',
  },
  { code: 'SA', flag: '🇸🇦', name: { en: 'Saudi Arabia', da: 'Saudi-Arabien' }, vatPrefix: 'SA' },
  { code: 'SG', flag: '🇸🇬', name: { en: 'Singapore', da: 'Singapore' }, vatPrefix: 'SG' },
  { code: 'KR', flag: '🇰🇷', name: { en: 'South Korea', da: 'Sydkorea' }, vatPrefix: 'KR' },
  { code: 'TH', flag: '🇹🇭', name: { en: 'Thailand', da: 'Thailand' }, vatPrefix: 'TH' },
  { code: 'ID', flag: '🇮🇩', name: { en: 'Indonesia', da: 'Indonesien' }, vatPrefix: 'ID' },
  { code: 'PH', flag: '🇵🇭', name: { en: 'Philippines', da: 'Filippinerne' }, vatPrefix: 'PH' },
];

// All countries (EU + non-EU)
export const ALL_COUNTRIES = [...EU_COUNTRIES, ...OTHER_COUNTRIES];

export const DEFAULT_COUNTRY_CODE = 'DK';

export function getCountryByCode(code: string): Country | undefined {
  return ALL_COUNTRIES.find((c) => c.code === code);
}

export function getCountryName(
  code: string | undefined | null,
  locale: 'en' | 'da' = 'da'
): string {
  if (!code) return '';
  const country = getCountryByCode(code);
  return country ? country.name[locale] : code;
}

/**
 * Get all countries as options for Select component
 * @param locale - Language code ('da' for Danish, 'en' for English)
 * @returns Array of {value, label} objects sorted alphabetically by label
 */
export function getCountryOptions(locale: 'en' | 'da' = 'da') {
  return ALL_COUNTRIES.map((country) => ({
    value: country.code,
    label: country.name[locale],
  })).sort((a, b) => a.label.localeCompare(b.label, locale === 'da' ? 'da-DK' : 'en-US'));
}
